import React from "react";
import { useTranslation } from "react-i18next";
import { ProductPrintConfiguration } from "../../data/global/useProductConfiguration";
import { HCPSpecificMessage } from "../../generate";
import EmailSellSheetRow from "../Email/EmailSellSheetRow";
import MessagesSellSheetRow from "./MessagesSellSheetRow";

interface Props {
  client: string;
  hcp: HCPSpecificMessage;
  isPrint: boolean;
  printConfig: ProductPrintConfiguration;
}

const ExpandedActions: React.FC<Props> = ({ client, hcp, isPrint, printConfig }) => {
  const messages = hcp.messages || [];

  const [t] = useTranslation();

  return (
    <div className="sm:p-4">
      <div className="flex">
        <div className="hidden sm:block w-56 text-xs">{t("specificMessages.actionItems")}</div>
        <div className="hidden sm:block text-xs">{t("specificMessages.sellSheets")}</div>
      </div>
      {messages.map((sellSheet, index) =>
        isPrint ? (
          <MessagesSellSheetRow key={index} client={client} hcp={hcp} sellSheet={sellSheet} />
        ) : (
          <EmailSellSheetRow key={index} client={client} hcp={hcp} sellSheet={sellSheet} printConfig={printConfig} />
        ),
      )}
    </div>
  );
};

export default ExpandedActions;
